module.exports = __webpack_public_path__ + "media/svg/nr-70356aea.svg";